const industries = [
  {
    id: 1,
    name: "Apparel",
  },
  {
    id: 2,
    name: "Automobile",
  },
  {
    id: 3,
    name: "Bank",
  },
  {
    id: 4,
    name: "Cement",
  },
  {
    id: 5,
    name: "Constructions",
  },
  {
    id: 6,
    name: "Electronics",
  },
  {
    id: 7,
    name: "FMCG",
  },
  {
    id: 8,
    name: "Food",
  },
  {
    id: 9,
    name: "GEO Textile",
  },
  {
    id: 10,
    name: "Iron",
  },
  {
    id: 11,
    name: "IT",
  },
  {
    id: 12,
    name: "Leather And Footwear",
  },
  {
    id: 13,
    name: "Mobile",
  },
  {
    id: 14,
    name: "Packaging",
  },
  {
    id: 15,
    name: "Pharma And Medicine",
  },
  {
    id: 16,
    name: "Poly Fiber",
  },
  {
    id: 17,
    name: "Testing Lab",
  },
  {
    id: 18,
    name: "Steel Fabrication",
  },
  {
    id: 19,
    name: "Galvanizing",
  },
  {
    id: 20,
    name: "Geo Textile",
  },
  {
    id: 21,
    name: "PEB",
  },
  {
    id: 22,
    name: "Shipping",
  },
  {
    id: 23,
    name: "Electric Transformer",
  },
  {
    id: 24,
    name: "Jute",
  },
];

export default industries;
